

































































import { mapGetters, mapActions } from 'vuex'
import CookieGroupSetting from './CookieGroupSetting.vue'
import { essentialCookies } from './essential-cookies'
import { analyticCookies } from './analytics-cookies'
import { i18n } from '@/plugins/i18n'

export default {
  components: {
    CookieGroupSetting
  },
  props: {
    startShowingIndividualSettings: { type: Boolean, default: false }
  },
  data() {
    return {
      show: false,
      individualSettingsVisible: false
    }
  },
  computed: {
    ...mapGetters(['selectedCookies', 'userHasAcceptedAnalyticsCookies']),
    essentialCookieGroup() {
      return essentialCookies(i18n)
    },
    analyticsCookieGroup() {
      return analyticCookies(i18n)
    }
  },
  created() {
    this.initSelectedCookies()
    this.individualSettingsVisible = this.startShowingIndividualSettings
  },
  methods: {
    ...mapActions(['initSelectedCookies', 'acceptCookies']),
    open() {
      this.show = true
    },
    close() {
      this.show = false
      this.$emit('close')
    },
    async acceptAllCookies() {
      await this.acceptCookies(['ESSENTIAL', 'ANALYTICS'])
      this.close()
    },
    async acceptEssentialCookies() {
      await this.acceptCookies(['ESSENTIAL'])
      this.close()
    },
    showIndividualSettings() {
      this.individualSettingsVisible = true
    },
    async acceptSelectedCookies() {
      await this.acceptCookies(this.selectedCookies)
      this.close()
    }
  }
}
